import { LayoutModalsState, SocialHubConfiguration } from '../../models/layout'

export enum LayoutActions {
    SET_IS_APP = 'setIsApp',
    SET_SHOW_SIDEBAR = 'setShowSidebar',
    SET_SHOW_NAVBAR = 'setShowNavbar',
    SET_SHOW_FAB_BUTTON = 'setShowFabButton',
    SET_SHOW_BACK_TO_TOP = 'setShowBackToTop',
    SET_MODALS = 'setModals',
    SET_BOTTOM_FAB_BUTTON = 'setBottomFabButton',
    SET_IS_CHATBOT_OPEN = 'setIsChatbotOpen',
    PUSH_BREADCRUMB = 'PUSH_BREADCRUMB',
    DELETE_BREADCRUMB = 'DELETE_BREADCRUMB',
    RESET_BREADCRUMB = 'RESET_BREADCRUMB',
    SET_BREADCRUMB_NAVIGATION = 'SET_BREADCRUMB_NAVIGATION',
    SET_SOCIAL_HUB_CONFIGURATION = 'SET_SOCIAL_HUB_CONFIGURATION',
}

export const setIsApp = (value: boolean) => {
    return { type: LayoutActions.SET_IS_APP, value }
}
export const setShowNavbar = (value: boolean) => {
    return { type: LayoutActions.SET_SHOW_NAVBAR, value }
}
export const setShowSidebar = (value: boolean) => {
    return { type: LayoutActions.SET_SHOW_SIDEBAR, value }
}
export const setShowFabButton = (value: boolean) => {
    return { type: LayoutActions.SET_SHOW_FAB_BUTTON, value }
}
export const setShowBackToTop = (value: boolean) => {
    return { type: LayoutActions.SET_SHOW_BACK_TO_TOP, value }
}
export const setModals = (value: Partial<LayoutModalsState>) => {
    return { type: LayoutActions.SET_MODALS, value }
}
export const setBottomFabButton = (value: Partial<string>) => {
    return { type: LayoutActions.SET_BOTTOM_FAB_BUTTON, value }
}
export const setIsChatbotOpen = (value: boolean) => {
    return { type: LayoutActions.SET_IS_CHATBOT_OPEN, value }
}

export const pushBreadcrumb = (breadcrumb: any) => {
    return {
        type: LayoutActions.PUSH_BREADCRUMB,
        breadcrumbs: breadcrumb,
    }
}
export const deleteBreadcrumb = (index?: number) => {
    return {
        type: LayoutActions.DELETE_BREADCRUMB,
        index: index,
    }
}
export const resetBreadcrumb = () => {
    return {
        type: LayoutActions.RESET_BREADCRUMB,
    }
}
export const setBreadcrumbNavigation = (breadcrumbNavigation: any) => {
    return {
        type: LayoutActions.SET_BREADCRUMB_NAVIGATION,
        breadcrumbNavigation: breadcrumbNavigation,
    }
}
export const setSocialHubConfiguration = (
    configuration: Partial<SocialHubConfiguration>
) => {
    return {
        type: LayoutActions.SET_SOCIAL_HUB_CONFIGURATION,
        configuration,
    }
}
